module.exports = __webpack_public_path__ + "img/20180815_150119_048.462d0263.jpg";